import {
  GET_GOOGLEAUTOSUGGESTIONS,
  GET_GOOGLEMAPPLACEDETAILS,
  GET_GOOGLEMAPDIRECTION,
  GET_GEOCODE,
  GET_RIDEDETAILSPOLYLINE,
} from "resources/actionTypes";

const intialState = {
  userAutoComplete: [],
  loading: false,
  fieldTypeLoader: "",
  error: null,
};
const intialDirectionState = {
  userDirection: [],
  viaUserDirection: {},
  loading: false,
  error: null,
};
const intialPlaceDetailsState = {
  userLocationDetails: [],
  pickup: [],
  drop: [],
  landmark:[],
  loading: false,
  error: null,
};
const intialStateGeo = {
  userGeocode: [],
  loading: false,
  error: null,
};

const initialRideDetails = {
  userRideDetails: [],
  loading: false,
  error: null,
};

export function userAutoComplete(state = intialState, action) {
  switch (action.type) {
    case GET_GOOGLEAUTOSUGGESTIONS.GET_GOOGLEAUTOSUGGESTIONS_REQUESTED:
      return {
        ...state,
        loading: true,
        fieldTypeLoader: action?.payload?.locationType
      };
    case GET_GOOGLEAUTOSUGGESTIONS.GET_GOOGLEAUTOSUGGESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        userAutoComplete: action.userAutoComplete,
        fieldTypeLoader: ""
      };
    case GET_GOOGLEAUTOSUGGESTIONS.GET_GOOGLEAUTOSUGGESTIONS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
        fieldTypeLoader: ""
      };
      case GET_GOOGLEAUTOSUGGESTIONS.GET_GOOGLEAUTOSUGGESTIONS_CLEARED:
      return {
        ...state,
        loading: false,
        userAutoComplete: [],
      };
    default:
      return state;
  }
}
export function userPlaceDetails(state = intialPlaceDetailsState, action) {
  switch (action.type) {
    case GET_GOOGLEMAPPLACEDETAILS.GET_GOOGLEMAPPLACEDETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_GOOGLEMAPPLACEDETAILS.GET_GOOGLEMAPPLACEDETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        userLocationDetails: {
          pickup: "pickup",
          drop: "drop",
          landmark:'landmark'
        },
      };
    case GET_GOOGLEMAPPLACEDETAILS.GET_GOOGLEMAPPLACEDETAILSPICKUP_SUCCESS:
      return {
        ...state,
        loading: false,
        pickup: action.userPlaceDetails,
      };
    case GET_GOOGLEMAPPLACEDETAILS.GET_GOOGLEMAPPLACEDETAILSDROP_SUCCESS:
      return {
        ...state,
        loading: false,
        drop: action.userPlaceDetails,
      };
    case GET_GOOGLEMAPPLACEDETAILS.GET_GOOGLEMAPPLACEDETAILSLANDMARK_SUCCESS:
      return {
        ...state,
        loading: false,
        landmark: action.userPlaceDetails,
      };
    case GET_GOOGLEMAPPLACEDETAILS.GET_GOOGLEMAPPLACEDETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
      case GET_GOOGLEMAPPLACEDETAILS.GET_GOOGLEMAPPLACEDETAILS_CLEARED:
      return {
        ...state,
        loading: false,
        pickup: "",
        drop: "",
        landmark:''
      };
    default:
      return state;
  }
}
export function userDirection(state = intialDirectionState, action) {
  switch (action.type) {
    case GET_GOOGLEMAPDIRECTION.GET_GOOGLEMAPDIRECTION_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_GOOGLEMAPDIRECTION.GET_GOOGLEMAPDIRECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        userDirection: action.userDirection,
      };
    case GET_GOOGLEMAPDIRECTION.GET_GOOGLEMAPDIRECTION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
export function userGeocode(state = intialStateGeo, action) {
  switch (action.type) {
    case GET_GEOCODE.GET_GEOCODE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_GEOCODE.GET_GEOCODE_SUCCESS:
      return {
        ...state,
        loading: false,
        userGeocode: action.userGeocode,
      };
    case GET_GEOCODE.GET_GEOCODE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userRideDetailsPolylines(state = initialRideDetails, action) {
  switch (action.type) {
    case GET_RIDEDETAILSPOLYLINE.GET_RIDEDETAILSPOLYLINE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_RIDEDETAILSPOLYLINE.GET_RIDEDETAILSPOLYLINE_SUCCESS:
      return {
        ...state,
        loading: false,
        userRideDetails: action.userRideDetail,
      };
    case GET_RIDEDETAILSPOLYLINE.GET_RIDEDETAILSPOLYLINE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
